import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import ValidateUserPlan from "../validateUserPlan.js";
import { getUserPlanDetails } from "../../apis/auth";

const ALLRoutes: React.FC = () => {
  const [token, setToken] = useState<string | null | undefined>(undefined);
  const [isPlanExpired, setIsPlanExpired] = useState<boolean | null>(null);

  const fetchPlanDetails = async () => {
    const res = await getUserPlanDetails();
    const userPlans = res?.data?.invoice?.filter((v) => v.type == "plan" || v.type == "subscription");
    userPlans?.sort((a, b) => b.id - a.id);
    const userCurrentPlan = userPlans?.[0];
    const isExpired = userCurrentPlan?.end_date && new Date(userCurrentPlan?.end_date) < new Date();
    setIsPlanExpired(isExpired);
  };

  useEffect(() => {
    fetchPlanDetails();
  }, []);

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    setToken(storedToken);
  }, []);

  if (token === undefined) {
    return null;
  }

  return (
    <Routes>
      {token ? (
        isPlanExpired ? (
          // 👇 If token exists but plan is expired, only show this screen
          <>
            <Route path="/validate-plan" element={<ValidateUserPlan />} />
            <Route path="*" element={<Navigate to="/validate-plan" replace />} />
          </>
        ) : (
          <Route element={<Feature />}>
            {publicRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={`pub-${idx}`} />
            ))}
            {authRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={`auth-${idx}`} />
            ))}
            {/* Redirect login or public-only screens to home if already logged in */}
            <Route path="/login" element={<Navigate to="/index" replace />} />
          </Route>
        )
      ) : (
        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={`auth-${idx}`} />
          ))}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Route>
      )}
    </Routes>
  );
};

export default ALLRoutes;
